import EditSystemPeriodicity from './containers/EditSystemPeriodicityContainer'

export default EditSystemPeriodicity
